import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
	return (
		<div className="bg-white text-[#4e4e4e] font-sans">
			<Navbar />
			<Hero />
			<About />
			<Services />
			<Contact />
			<Footer />
		</div>
	);
}

export default App;
